import {
    FloatingLabel,
    FormControl,
    FormGroup,
    FormLabel,
} from "react-bootstrap";
import styled from "styled-components";

const StyledFormGroup = styled(FormGroup)`
    position: relative;
    > input {
        font-size: 16px;
        border: 0;
        border-bottom: 2px solid lightgrey;
        border-radius: 0;
        outline: none;
        left: 10px;
        min-width: 180px;
    }
    > label {
        pointer-events: none;
        position: absolute;
    }
`;

const StyledFormControl = styled(FormControl)`
    width: 100%;
    padding: 12px;
    color: #000000;
    border-color: #787878;
    border-width: 1px 1px 1px 1px;
    border-radius: 4px;
    &:hover {
        border-color: #9654ff;
        box-shadow: none;
    }
    &:active {
        border-color: #9654ff;
        box-shadow: none;
    }
    &:focus {
        border-color: #9654ff;
        box-shadow: none;
    }
    &:focus-visible {
        border-color: #9654ff;
        box-shadow: none;
        outline: none;
    }
    &:disabled {
        background-color: #e9ecef;
    }
`;

const StyledFloatingLabel = styled(FloatingLabel)`
    label {
        top: -5px;
        font-size: 14px;
    }
    .form-control {
        height: 48px;
        line-height: 1.25;
    }
    .form-control-plaintext {
        height: 48px;
        line-height: 1.25;
    }
    .form-select {
        height: 48px;
        line-height: 1.25;
    }
`;

const StyledLabel = styled(FormLabel)`
    font-size: 15px;
    line-height: 25px;
    margin: 0;
    margin-bottom: 0;
    display: flex;
`;

const StyledLabelFloating = styled(FormLabel)`
    font-weight: 400;
    font-size: 12px;
    text-align: left;
    color: #787878;
    width: calc(100% - 19px);
    background-color: #fff;
    margin-top: 1px;
    margin-left: 1px;
    padding-top: 5px;
    padding-left: 13px;
    padding-bottom: 5px;
    border-style: hidden;
`;

const StyledLengthInfo = styled.p`
    color: #787878;
    font-weight: 400;
    font-size: 13px;
    display: flex;
    justify-content: flex-end;
`;

export default {
    StyledFormGroup,
    StyledFormControl,
    StyledFloatingLabel,
    StyledLabel,
    StyledLabelFloating,
    StyledLengthInfo,
};
